import styled from 'styled-components'

const GlobalStyles = styled.div`
  color: ${(props) => props.theme.text};
  ${'' /* background-color: ${(props) => props.theme.background}; */}
  ${'' /* font-family: ${(props) => props.theme.font}; */}
  font-family: 'Montserrat', sans-serif;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  over-flow-x: hidden;
  scroll-x: none;
  background: linear-gradient(
    45deg,
    white,
    #65b283,
    #184f9d,
    transparent,
    transparent
  );
  animation: gradient 15s ease infinite;

  /* #65b283   #184f9d */

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  button {
    background-color: rgb(0, 0, 0, 0.75);
    color: ${(props) => props.theme.text};
    padding: 0.5rem 1rem;
    background:
      linear-gradient(rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75)) padding-box,
      linear-gradient(
          -205deg,
          ${(props) => props.theme.primary},
          ${(props) => props.theme.secondary}
        )
        border-box;
    border-radius: 0.25rem;
    border: 2px solid transparent;
    color: darkblue;
    padding: 0.5rem 1rem;
    color: ${(props) => props.theme.text};
    cursor: pointer;
  }

  .brand-mark {
    width: 98vw;
    height: 98vw;
    position: absolute;
    top: 15%;
    left: 2%;
    z-index: -1;
    opacity: 10%;
  }

  .logo {
    height: 30%;
  }

  .nav-burger {
    height: 50%;
  }

  .amp {
    font-family: 'Ubuntu', sans-serif;
  }
`

export default GlobalStyles
